import { render, staticRenderFns } from "./AuthLoader.vue?vue&type=template&id=c8fb317a"
import script from "./AuthLoader.vue?vue&type=script&lang=js"
export * from "./AuthLoader.vue?vue&type=script&lang=js"
import style0 from "./AuthLoader.vue?vue&type=style&index=0&id=c8fb317a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports